import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css';

NProgress.configure({ showSpinner: false });
//Components
Vue.use(VueRouter)

const routes = [
	{
		name : 'login',
		path : '/login',
		component : () => import(/* webpackChunkName: "login" */ '@/pages/Login'),
		meta : {
			requiresVisitor : true
		}
	},
	{
		name : 'signup',
		path : '/signup',
		component : () => import(/* webpackChunkName: "signup" */ '@/pages/SimpleSignUp'),
		meta : {
			requiresVisitor : true
		}
	},
	{
		name : 'guest-signup',
		path : '/guest-signup',
		component : () => import(/* webpackChunkName: "guest-signup" */ '@/pages/GuestSignup'),
		meta : {
			requiresVisitor : true
		}
	},
	{
		name : 'login-school',
		path : '/login-school',
		component : () => import(/* webpackChunkName: "login" */ '@/pages/LoginSchool'),
		meta : {
			requiresVisitor : true
		}
	},
	{
		name : 'home',
		path : '/',
		component : () => import(/* webpackChunkName: "home" */ '@/pages/Home'),
		meta : {
			requiresAuth : true
		}
	},
	{
		name : 'profile',
		path : '/profile',
		component : () => import(/* webpackChunkName: "profile" */ '@/pages/Profile'),
		meta : {
			requiresAuth : true
		}
	},
	{
		name : 'billing',
		path : '/billing',
		component : () => import(/* webpackChunkName: "profile" */ '@/pages/Billing'),
		meta : {
			requiresAuth : true
		}
	},
	//Masters,
	{
		name : 'subject',
		path : '/subject',
		component : () => import(/* webpackChunkName: "subject" */ '@/pages/Subject'),
		meta : {
			requiresAuth : true
		}
	},
	{
		name : 'grade',
		path : '/grade',
		component : () => import(/* webpackChunkName: "grade" */ '@/pages/Grade'),
		meta : {
			requiresAuth : true
		}
	},
	{
		name : 'gradesubject',
		path : '/gradesubject',
		component : () => import(/* webpackChunkName: "gradesubject" */ '@/pages/GradeSubject'),
		meta : {
			requiresAuth : true
		}
	},
	{
		name : 'gradesubjectdetail',
		path : '/gradesubject/:id',
		component : () => import(/* webpackChunkName: "gradesubjectdetail" */ '@/pages/GradeSubjectDetail'),
		props : true,
		meta : {
			requiresAuth : true
		}
	},
	{
		name : 'clipart',
		path : '/clipart',
		component : () => import(/* webpackChunkName: "subject" */ '@/pages/Clipart'),
		meta : {
			requiresAuth : true
		}
	},
	{
		name : 'picturelibrary',
		path : '/picturelibrary',
		component : () => import(/* webpackChunkName: "subject" */ '@/pages/PictureLibrary'),
		meta : {
			requiresAuth : true
		}
	},
	{
		name : 'pending-explanations',
		path : '/pending-explanations',
		component : () => import(/* webpackChunkName: "pending-explanations" */ '@/pages/PendingExplanations'),
		meta : {
			requiresAuth : true
		}
	},
	// Kid Practice
	{
		name : 'kiddetail_practice',
		path : '/kid/:kid_id/practice',
		component : () => import(/* webpackChunkName: "kiddetail-practice" */ '@/pages/KidPractice'),
		props : true,
		meta : {
			requiresAuth : true
		}
	},
	// Kid - Analytics
	{
		name : 'kiddetail_analytics',
		path : '/kid/:kid_id/analytics',
		component : () => import(/* webpackChunkName: "kiddetail-analytics" */ '@/pages/KidAnalytics'),
		props : true,
		meta : {
			requiresAuth : true
		}
	},
	// Kid - List of Categories inside Grade Subject 
	{
		name : 'kiddetail_categories',
		path : '/kid/:kid_id/practice/:grade_subject_id/category',
		component : () => import(/* webpackChunkName: "kiddetail-categories" */ '@/pages/KidGradeSubjectCategories'),
		props : true,
		meta : {
			requiresAuth : true
		}
	},
	// Kid - List of Subcategories inside a Category
	{
		name : 'kiddetail_category_subcategories',
		path : '/kid/:kid_id/practice/:grade_subject_id/category/:category_id/subcategory',
		component : () => import(/* webpackChunkName: "kiddetail_category_subcategories" */ '@/pages/KidCategorySubcategories'),
		props : true,
		meta : {
			requiresAuth : true
		}
	},
	// Kid - List of Skills inside a category
	{
		name : 'kiddetail_category_skills',
		path : '/kid/:kid_id/practice/:grade_subject_id/category/:category_id/skill',
		component : () => import(/* webpackChunkName: "kiddetail_category_skills" */ '@/pages/KidCategorySkills'),
		props : true,
		meta : {
			requiresAuth : true
		}
	},
	//Quiz
	{
		name : 'quiz',
		path : '/kid/:kid_id/practice/:grade_subject_id/category/:category_id/skill/:skill_id',
		component : () => import(/* webpackChunkName: "quiz" */ '@/pages/Quiz'),
		props : true,
		meta : {
			requiresAuth : true
		}
	},
	
	//All users
	{
		name : 'user',
		path : '/user',
		component : () => import(/* webpackChunkName: "user" */ '@/pages/User'),
		meta : {
			requiresAuth : true
		}
	},

	// Schools (Upskool Admin only)
	{
		name : 'schools',
		path : '/schools',
		component : () => import(/* webpackChunkName: "schools" */ '@/pages/Schools'),
		meta : {
			requiresAuth : true
		}
	},

	{
		name: 'signup',
		path: '/signup',
		component:() => import(/* webpackChunkName: "signup" */ '@/pages/SignUp'),
		meta:{
		}
	},
	{
		name: 'profile1',
		path: '/profile1',
		component:() => import(/* webpackChunkName: "signup" */ '@/pages/Profile1'),
		meta:{
		}
	},
	{
		name: 'membership',
		path: '/membership',
		component:() => import(/* webpackChunkName: "membership" */ '@/pages/Membership'),
		meta:{
		}
	},
	{
		name: 'school-home',
		path: '/school-home',
		component:() => import(/* webpackChunkName: "signup" */ '@/pages/SchoolHome'),
		meta:{
		}
	},
	
	{
		name: 'manage-account',
		path: '/manage-account',
		component:() => import(/* webpackChunkName: "manage-account" */ '@/pages/ManageAccount'),
		meta:{
		}
	},
	
	{
		name: 'classrooms',
		path: '/classrooms',
		component:() => import(/* webpackChunkName: "signup" */ '@/pages/Classrooms'),
		meta:{
		}
	},

	{
		name: 'classroom-details',
		path : '/classroom-details/:id',
		component:() => import(/* webpackChunkName: "signup" */ '@/components/School/ClassroomDetails'),
		props:true,
		meta:{
		}
	},
	
	{
		name : 'view-categories',
		path : '/school/practice/:grade_subject_id/category',
		component : () => import(/* webpackChunkName: "school-categories" */ '@/components/School/ViewCategories'),
		props : true,
		meta : {
			requiresAuth : true
		}
	},
	{
		name: 'badges',
		path: '/badges',
		component:() => import(/* webpackChunkName: "signup" */ '@/pages/Badges'),
		meta:{
		}
	},
	{
		name: 'userclassrooms',
		path: '/kid/:kid_id/userclassrooms',
		component:() => import(/* webpackChunkName: "signup" */ '@/components/School/UserClassrooms'),
		props:true,
		meta : {
			requiresAuth : true
		}
	},
]

const router = new VueRouter({
	base : '/',
	routes,
	mode : 'history'
})

// router.beforeResolve((to, from, next) => {
//   // If this isn't an initial page load.
//   if (to.name && from.name) {
//     // Start the route progress bar.
//     NProgress.start()
//   }
//   next()
// })

//Protecting routes
router.beforeEach((to, from, next) => {
  NProgress.start()
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!store.getters.isLoggedIn){
      next({
        name : 'login'
      })
    } else {
      next()
    }
  }else if (to.matched.some(record => record.meta.requiresVisitor)) {
    // this route requires visitor, check if not logged in
    // if not, redirect to login page.
    if (store.getters.isLoggedIn){
      next({
        name : 'home'
      })
    } else {
      next()
    }
  } else {
    next() // make sure to always call next()!
  }
})

router.afterEach(() => {
  // Complete the animation of the route progress bar.
  NProgress.done()
})

router.onError(error => {
  if (/loading chunk \d* failed./i.test(error.message)) {
    window.location.reload()
  }
})

export default router